if(!customElements.get('bis-modal')) {
  class bisModal extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector('dialog');
      this.bisForm = this.querySelector('form');
      this.productTitle = this.querySelector('[data-product-title]');
      this.variantName = this.querySelector('[data-product-variant]');
      this.variantId = this.querySelector('[data-bis-variant-id]');
      this.productId = this.querySelector('[data-bis-product-id]');
      this.bisTypeSelectors = this.querySelectorAll('input[type="radio"]');
      this.closeButton = this.querySelector('[data-close-button]');
      this.newsletterCheckbox = this.querySelector('[data-consent-checkbox]');
      this.smsDisclaimer = this.querySelector('[data-sms-disclaimer]');
      this.zipCodeField = this.querySelector('[data-zip-code-field]')

      this.intlPhoneNumberSelector();
    }

    connectedCallback() {
      document.addEventListener('bisForm:open', this.openModal.bind(this));

      this.bisTypeSelectors.forEach((radio) => {
        radio.addEventListener('change', (evt) => {
          let emailAction = 'remove';
          let smsAction = 'add';
          let emailSelector = this.querySelector('input[type="email"]');
          let smsSelector = this.querySelector('input[type="tel"]');
          let smsWrapper = smsSelector.closest('.iti');
          if(evt.target.value == 'sms') {
            emailAction = 'add';
            smsAction = 'remove';
          }
          emailSelector.classList[emailAction]('hidden');
          smsWrapper.classList[smsAction]('hidden');
          this.smsDisclaimer.classList[smsAction]('hidden');
        })
      })
      this.bisForm?.addEventListener('submit', this.submitModal.bind(this));
      this.closeButton.addEventListener('click', this.closeModal.bind(this));
    }

    openModal(evt) {
      const info = evt.detail;

      this.productTitle.innerText = info.productTitle;
      this.variantName.innerText = info.variantTitle;
      this.productId.value = info.productId;
      this.variantId.value = info.variantId;

      this.dialog.showModal();
    }

    closeModal() {
      this.dialog.close();
    }

    intlPhoneNumberSelector() {
      if(!window.intlTelInput) {
        setTimeout(() => {
          this.intlPhoneNumberSelector();
        }, 200)
      } else {
        const activeSelector = Array.from(this.bisTypeSelectors).filter((element) => element.checked == true);
        this.bisPhone = window.intlTelInput(this.querySelector('input[type="tel"]'), {
          initialCountry: Shopify.country,
          containerClass: activeSelector.value == 'email' ? 'hidden' : '',
          loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js"),
        })
      }
    }

    validateFields() {
      const inputs = Array.from(this.querySelectorAll('input[required]')).filter((input) => !input.classList.contains('hidden'));
      let formValid = true;

      inputs.forEach((input) => {
        if(!input.checkValidity()) {
          if(formValid) {
            input.focus();
          }

          formValid = false;
          input.classList.add('has-error');
          input.addEventListener('keyup', (evt) => {
            evt.target.classList.remove('has-error');
          }, {once: true} )
        }
      })

      return formValid;
    }

    updateFormMessage({
      message,
      success
    }) {
      const confirmMessage = this.querySelector("[data-confirm-message]");
      const successIcon = this.querySelector(".bis-modal-form__confirm-message svg");

      if(!success) {
        successIcon.style.display = "none";
        confirmMessage.style.color = "var(--color-error)"
      }

      confirmMessage.innerHTML = message;
      confirmMessage.parentElement.removeAttribute('hidden');

      setTimeout(() => {
        confirmMessage.parentElement.setAttribute('hidden', true);
        confirmMessage.removeAttribute('style');
        successIcon.removeAttribute('style');
      }, 5000);
    }

    submitModal(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      const validForm = this.validateFields();

      if(!validForm) {
        this.updateFormMessage({
          message: "All fields are required",
          success: false
        })
        return;
      }

      const selectedType = Array.from(this.bisTypeSelectors).find(
        (selector) => selector.checked
      );
      const zipCode = this.zipCodeField.value;

      const payload = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            channels: [],
            profile: {
              data: {
                type: "profile",
                attributes: {},
              },
            },
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${this.variantId.value}`,
              },
            },
          },
        },
      };

      const consentPayload = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  subscriptions: {},
                  properties: {},
                },
              },
            },
            custom_source: "Back in stock form",
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: "V3hrKA",
              },
            },
          },
        },
      };

      const updatePayload = {
        data: {
          type: "profile",
          attributes: {
            properties: {},
          }
        }
      }

      if (selectedType.value == "email") {
        const email = this.bisForm.querySelector('input[type="email"').value;

        payload.data.attributes.channels.push("EMAIL");
        payload.data.attributes.profile.data.attributes.email = email;

        if(this.newsletterCheckbox.checked == true) {
          consentPayload.data.attributes.profile.data.attributes.subscriptions = {
            email: {
              marketing: {
                consent: "SUBSCRIBED",
              }
            }
          }

          consentPayload.data.attributes.profile.data.attributes.email = email;
          if(zipCode) {
            consentPayload.data.attributes.profile.data.attributes.properties["zip-code"] = zipCode;
          }
        } else {
          updatePayload.data.attributes.email = email;

          if(zipCode) {
            updatePayload.data.attributes.properties["zip-code"] = zipCode;
          }
        }
      } else if (selectedType.value == "sms") {
        let phone = this.bisPhone.getNumber();

        payload.data.attributes.channels.push("SMS");
        payload.data.attributes.profile.data.attributes.phone_number = phone;

        if(this.newsletterCheckbox.checked == true) {
          consentPayload.data.attributes.profile.data.attributes.subscriptions = {
            sms: {
              marketing: {
                consent: "SUBSCRIBED",
              }
            }
          }

          consentPayload.data.attributes.profile.data.attributes.phone_number = phone;
          if(zipCode) {
            consentPayload.data.attributes.profile.data.attributes.properties["zip-code"] = zipCode;
          }
        } else {
          updatePayload.data.attributes.phone_number = phone;

          if(zipCode) {
            updatePayload.data.attributes.properties["zip-code"] = zipCode;
          }
        }
      }

      fetch(
        "https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=KkSJyW",
        {
          headers: {
            accept: "application/vnd.api+json",
            "content-type": "application/vnd.api+json",
            revision: "2025-04-15",
          },
          method: "post",
          body: JSON.stringify(payload),
        }
      ).then(async (data) => {
        if (data.status == 202) {
          // Subscribe the customer to the newsletter if the BIS subscripton was successful
          if(this.newsletterCheckbox.checked == true) {
            fetch("https://a.klaviyo.com/client/subscriptions?company_id=KkSJyW", {
              headers: {
                accept: "application/vnd.api+json",
                "content-type": "application/vnd.api+json",
                revision: "2025-07-15"
              },
              method: "post",
              body: JSON.stringify(consentPayload)
            }).then(async (data) => {
              if (data.status !== 202) {
                const response = await data.json();
                const errorsMsg = response.errors.map((error) => {
                  return error.detail;
                })

                console.log('[BIS form] - Error subscribing to newsletter'),
                console.log(errorsMsg)
              }
            })
          } else if(zipCode) {
            fetch("https://a.klaviyo.com/client/profiles?company_id=KkSJyW", {
              headers: {
                accept: "application/vnd.api+json",
                "content-type": "application/vnd.api+json",
                revision: "2025-07-15"
              },
              method: "post",
              body: JSON.stringify(updatePayload)
            })
          }


          this.updateFormMessage({
            message: "We'll Notify You When It's Back In Stock",
            success: true,
          })
        } else {
          const response = await data.json();
          const errorsMsg = await response.errors.map((error) => {
            return error.detail;
          });
          this.updateFormMessage({
            message: errorsMsg.join("<br/>"),
            success: false
          })
        }
      });
    }
  }

  customElements.define('bis-modal', bisModal);
}